export default ({
  fetching: {
    listAgents: false,
    getAgent: false,
    createAgent: false,
    updateAgent: false,
    deleteAgent: false,
    duplicateAgent: false,
    uploadDocument: false,
    deleteDocument: false,
    testAgent: false,
  },
  api: {
    agents: [],
    currentAgent: null,
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    filters: {
      search: '',
      status: '',
    },
    chatMessages: [],
  },
});

